import { hasStringValue, isSelected } from "@utilities";

const clientPlanTurn = [
  {
    field: "clientPlanTurn.0.data.incPaym",
    validation: isSelected
  },
  {
    field: "clientPlanTurn.0.data.incRem",
    validation: isSelected
  }
];

const clientPaymentForServises = [
  {
    field: "clientPaymentForServises.0.data.clientPaymCash",
    validation: isSelected
  },
  {
    field: "clientPaymentForServises.0.data.clientPaymCryp",
    validation: isSelected
  }
];

const clientFundsRecCountries = [
  {
    field: "clientFundsRecCountrys.$index.data.clientFundsRecCountry",
    validation: hasStringValue
  }
];

const clientFundsSentCountries = [
  {
    field: "clientFundsSentCountry.$index.data.clientFundsSentCountry",
    validation: hasStringValue
  }
];

const mainCustomer = [
  {
    field: "mainCustom.$index.data.customerName",
    validation: hasStringValue
  },
  {
    field: "mainCustom.$index.data.customerActivity",
    validation: hasStringValue
  },
  {
    field: "mainCustom.$index.data.customerCountry",
    validation: hasStringValue
  }
];

const businessPartners = [
  {
    field: "clientBusPartner.$index.data.clientBusPartnerName",
    validation: hasStringValue
  },
  {
    field: "clientBusPartner.$index.data.clientBusPartnerAct",
    validation: hasStringValue
  },
  {
    field: "clientBusPartner.$index.data.clientBusPartnerCountry",
    validation: hasStringValue
  }
];

const paymentsOut = [
  {
    field: "PaymOut.0.data.paymOut",
    validation: isSelected
  },
  {
    field: "PaymOut.0.data.remOut",
    validation: isSelected
  }
];

const planServiceTurn = [
  {
    field: "planServTurn.0.data.currExchange",
    validation: isSelected
  },
  {
    field: "planServTurn.0.data.loanSum",
    validation: isSelected
  },
  {
    field: "planServTurn.0.data.moInAcc",
    validation: isSelected
  }
];

const getMappedValidations = (totalEntries, validationArray) => {
  const mappedValidations = [];

  for (let i = 0; i < totalEntries; i++) {
    const indexValidation = [];

    for (let j = 0; j < validationArray.length; j++) {
      indexValidation.push({
        field: validationArray[j].field.replace("$index", i),
        validation: validationArray[j].validation
      });
    }
    mappedValidations.push(...indexValidation);
  }
  return mappedValidations;
};

export const getStep7Validations = ({
  totalFundsCountries,
  totalCustomers,
  validateCustomers,
  validateBusinessPartners,
  totalBusinessPartners,
  totalSentCountries
}) => [
  ...clientPlanTurn,
  ...clientPaymentForServises,
  ...planServiceTurn,
  ...paymentsOut,
  ...getMappedValidations(totalSentCountries, clientFundsSentCountries),
  ...getMappedValidations(totalFundsCountries, clientFundsRecCountries),
  ...(validateBusinessPartners
    ? [...getMappedValidations(totalBusinessPartners, businessPartners)]
    : []),
  ...(validateCustomers ? [...getMappedValidations(totalCustomers, mainCustomer)] : [])
];
